export default __webpack_public_path__ + "media/images/icons/sign-out-alt-solid-c00a4b7caa3105b0be000ff7f85238f6.svg";